import { Link } from "react-router-dom";
import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

export const LogoLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  transition: "all 0.2s ease",
  cursor: "pointer",

  "& > img": {
    width: "190px",
    height: "auto",
    objectFit: "contain",
    transition: "transform 0.3s ease",
    cursor: "inherit",

    [theme.down("sm")]: {
      width: "120px",
      height: "auto",
    },
  },

  "&:hover": {
    "& > img": {
      transform: "scale(1.05) rotate(-2deg)",
    },
  },
}));

export const LogoWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const LogoText = styled("span")(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 700,
  color: theme.palette.header.text,
  letterSpacing: "-0.02em",
  lineHeight: 1.2,

  [theme.down("md")]: {
    fontSize: "16px",
  },
}));

export const LogoSubtitle = styled("span")(({ theme }) => ({
  fontSize: "11px",
  fontWeight: 500,
  color: theme.palette.header.textSecondary,
  letterSpacing: "0.02em",
  lineHeight: 1,
  cursor: "pointer",

  [theme.down("md")]: {
    fontSize: "10px",
  },
}));
